/* @flow weak */
import cx from 'classnames';
import Link from 'components/Link.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

/**
 * ## [Link](/internal/components/Link) that sends an email.
 *
 *
 * ```example
 * <MailTo to="name@school.edu" />
 * ```
 *
 * ```example
 * <MailTo
 *   to="name@school.edu"
 *   cc="name1@school.edu"
 *   bcc="name2@school.edu"
 *   subject="Email subject"
 *   body="Email body">
 *   Send email
 * </MailTo>
 * ```
 */

class MailTo extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    to: PropTypes.string,
    cc: PropTypes.string,
    bcc: PropTypes.string,
    subject: PropTypes.string,
    body: PropTypes.string,
  };

  static defaultProps = {
    to: '',
    cc: '',
    bcc: '',
    subject: '',
    body: '',
  };

  getMailProps = () => {
    let props = [];
    const otherProps = ['subject', 'body', 'cc', 'bcc'];

    for (const p in this.props) {
      if (otherProps.indexOf(p) > -1 && this.props[p]) {
        props.push(`${p}=${this.getProp(p)}`);
      }
    }

    props = props.join('&');
    return props;
  };

  getMailToLink = () => {
    return `mailto:${this.getTo()}?${this.getMailProps()}`;
  };

  getProp = prop => {
    return encodeURIComponent(this.props[prop]);
  };

  getTo = () => {
    return this.props.to || '';
  };

  renderBody = () => {
    let body;

    if (this.props.children) {
      body = this.props.children;
    } else {
      body = this.getTo();
    }

    return body;
  };

  render() {
    const { className, to, ...other } = this.props; // eslint-disable-line no-unused-vars

    const mailto = (
      <Link
        {...other}
        href={this.getMailToLink()}
        target="_blank"
        className={cx('MailTo', className)}>
        {this.renderBody()}
      </Link>
    );

    return mailto;
  }
}

export default MailTo;
